import { render, staticRenderFns } from "./SocialView.vue?vue&type=template&id=4b04a72c&scoped=true&"
import script from "./SocialView.vue?vue&type=script&lang=js&"
export * from "./SocialView.vue?vue&type=script&lang=js&"
import style0 from "./SocialView.vue?vue&type=style&index=0&id=4b04a72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04a72c",
  null
  
)

export default component.exports